export const TRANSLATION_SCOPE_IMPORTS: Record<
  string,
  (language: string) => Promise<any>
> = {
  audit: (language) =>
    import(`../../../../features/audit/src/i18n/${language}.json`),
  certificate: (language) =>
    import(`../../../../features/certificates/src/i18n/${language}.json`),
  actions: (language) =>
    import(`../../../../features/actions/src/i18n/${language}.json`),
  contracts: (language) =>
    import(`../../../../features/contracts/src/i18n/${language}.json`),
  apps: (language) =>
    import(`../../../../features/external-apps/src/i18n/${language}.json`),
  financial: (language) =>
    import(`../../../../features/financials/src/i18n/${language}.json`),
  findings: (language) =>
    import(`../../../../features/findings/src/i18n/${language}.json`),
  notifications: (language) =>
    import(`../../../../features/notifications/src/i18n/${language}.json`),
  overview: (language) =>
    import(`../../../../features/overview/src/i18n/${language}.json`),
  schedules: (language) =>
    import(`../../../../features/schedules/src/i18n/${language}.json`),
  settings: (language) =>
    import(`../../../../features/settings/src/i18n/${language}.json`),
  whatsNew: (language) =>
    import(
      `../../../../features/feature-announcements/src/i18n/${language}.json`
    ),
};
